import { useTranslation } from "react-i18next";

import { Box, Center, Divider, Image, Paper, Stack, Text } from "@mantine/core";

import { QRCodeSVG } from "qrcode.react";

import { GuestInfoBite } from "./GuestInfoBite";
import PrettyLinkItems from "./pretty-link-items";

interface InfoCardProps {
  information: GuestInfoBite;
}

export function InfoCard({ information }: InfoCardProps) {
  const { t } = useTranslation();
  const url = `${window.location.protocol}//${window.location.host}/guests#${information._slug}`;

  return (
    <Stack gap="lg">
      <Box
        style={{ borderRadius: "var(--mantine-radius-lg)", overflow: "hidden" }}
      >
        <Image
          src={`/img/infos/${information._slug}.jpg`}
          alt={information.title}
          h={220}
          fit="cover"
          fallbackSrc="/img/pool-day.jpg"
        />
      </Box>

      <Stack gap={4}>
        <Text size="xs" tt="uppercase" c="dimmed" fw={600}>
          {t("guest.infoCard.labels.headline")}
        </Text>
        <Text size="lg" fw={500}>
          {information.instruction}
        </Text>
      </Stack>

      <Stack gap={4}>
        <Text size="xs" tt="uppercase" c="dimmed" fw={600}>
          {t("guest.infoCard.labels.moreDetail")}
        </Text>
        <Text>{information.blurb}</Text>
      </Stack>

      {information.links && information.links.length > 0 && (
        <>
          <Divider />
          <Stack gap={4}>
            <Text size="xs" tt="uppercase" c="dimmed" fw={600}>
              {t("guest.infoCard.labels.learnMore")}
            </Text>
            <PrettyLinkItems linkParent={information} />
          </Stack>
        </>
      )}

      <Divider />
      <Stack gap="sm" align="center">
        <Text size="xs" tt="uppercase" c="dimmed" fw={600}>
          {t("guest.infoCard.labels.comeBackLater")}
        </Text>
        <Paper p="md" radius="lg" withBorder bg="sea.0">
          <Center>
            <QRCodeSVG
              value={url}
              size={180}
              level="H"
              fgColor="#1c8bdc"
              bgColor="#ffffff"
              imageSettings={{
                src: "/apple-touch-icon.png",
                height: 36,
                width: 36,
                excavate: true,
              }}
            />
          </Center>
        </Paper>
        <Text size="xs" c="dimmed" ta="center">
          Scan to revisit on another device.
        </Text>
      </Stack>
    </Stack>
  );
}

export default InfoCard;
